import type { Market } from '@/domain/Market';

const ITEMS_PER_ROW = 5;
const MAX_ROWS = 3;
const MAX_ITEMS = ITEMS_PER_ROW * MAX_ROWS;
const SECOND_ROW_LIMIT = ITEMS_PER_ROW * 2;

/**
 * Generates an array of quantity options for a selector.
 * Optionally appends a custom third line of quantities.
 */
export function calculateQuantityOptions(
  step: number = 1,
  thirdRowQuantities: number[] = [],
  options?: Market
): number[] {
  const quantities: number[] = [];
  const isThirdRowDefined =
    options?.financialSettings?.pricingModel === 'CAPSULE' &&
    thirdRowQuantities.length > 0;

  for (let i = 0; quantities.length + 1 < MAX_ITEMS; i += step) {
    const currentIndex = i / step + 1;

    // If a third row is provided and we've filled the second row, append it and stop
    if (isThirdRowDefined && currentIndex > SECOND_ROW_LIMIT) {
      quantities.push(...thirdRowQuantities);
      break;
    }

    quantities.push(i);
  }

  return quantities;
}
